import React from 'react';
import HeroImage from 'assets/img/hero_image2.png';
import { Link } from 'react-router-dom';


const Hero = () => {
    return (
        <div className="flex flex-col md:flex-row items-center justify-between md:px-44 px-6 py-16 bg-japanese-paper min-h-screen">
            <div className="md:w-1/2">
                <img src={HeroImage} alt="Hero" className="w-full h-auto drop-shadow-lg" draggable="false" />
            </div>
            <div className="md:w-1/2 mt-8 md:mt-0 px-12">
                <h1 className="text-4xl md:text-5xl font-bold mb-6 text-center text-japanese-ink font-japanese leading-tight">
                    ¡Leer en japonés nunca fue tan fácil!
                </h1>
                <p className="text-lg text-charcoal-600 text-center mb-8 leading-relaxed">
                    Descubre la magia de los cuentos tradicionales japoneses mientras aprendes el idioma
                </p>
                <div className="flex flex-col space-y-4 justify-center w-3/4 m-auto">
                    <Link to="/cuentosDashboard">
                        <button className="w-full bg-primary-600 hover:bg-primary-700 hover:scale-105 transform transition-all duration-300 shadow-lg hover:shadow-xl text-pearl-50 font-bold py-4 px-8 rounded-2xl text-lg">
                            🌸 ¡Vamos a leer!
                        </button>
                    </Link>
                    {/* <button className="w-full bg-pearl-100 hover:bg-pearl-200 border-2 border-sage-400 hover:border-sage-500 text-sage-700 font-semibold py-3 px-6 rounded-2xl transition-all duration-300">
                        📖 Aprende más
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default Hero;